import React from "react";

function OurIDODevPro() {
  return (
    <>
      <div className="home-blog-two-area default-padding bg-gray blurry-shape-left-bottom">
        <div className="container">
          <div className="row">
            <div className="col-lg-8 offset-lg-2">
              <div className="site-heading text-center">
                <h4 className="sub-title">Latest Blog</h4>
                <h2 className="title split-text-right split-text-in-right split-lines">
                  Our IDO Development Process
                </h2>
                <p>
                  We will build your project from concept to launch with a
                  structured, secure, and scalable IDO process designed for
                  seamless fundraising and maximum market impact.
                </p>
              </div>
            </div>
          </div>
        </div>
        <div className="container">
          <div className="blog-style-two-box">
            <img src="https://xeertechnology.com/assets/img/coin-dev/our_ido_development_process_section_icon_file.svg" />
          </div>
        </div>
      </div>
    </>
  );
}

export default OurIDODevPro;
